import request from '../../axios';
import {IGetCooperationAgreementStatusResponse} from './types';

export const getCooperationAgreementStatus = async () => {
  const {data}: {data: IGetCooperationAgreementStatusResponse} =
    await request.get(`/api/v2/store/cooperation-agreement-status`);

  return data;
};
